"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ObjectExpressionExtractor;
(function (ObjectExpressionExtractor) {
    ObjectExpressionExtractor["BasePropertiesExtractor"] = "BasePropertiesExtractor";
    ObjectExpressionExtractor["ObjectExpressionToVariableDeclarationExtractor"] = "ObjectExpressionToVariableDeclarationExtractor";
})(ObjectExpressionExtractor = exports.ObjectExpressionExtractor || (exports.ObjectExpressionExtractor = {}));
